module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/17-8d5167890a76151d95b51b4cbb8eb53d.jpg";